import axios from 'axios'
import vue from 'vue'
import store from "../store/index.js";
axios.defaults.timeout = 10000
// axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8 ';


// //  添加请求拦截器
// axios.interceptors.request.use(

// 	// 在发送请求之前做些什么

// 	config => {
// 		config.headers.token = '57891704271465632'
// 		return config
// 	},
// 	// 对请求错误做些什么
// 	error => {
// 		return Promise.reject(error)
// 	}
// )
//添加响应拦截器
// axios.interceptors.response.use(
// 	response => {
// 		// 2xx 范围内的状态码都会触发该函数。
// 		// 对响应数据做点什么
// 		if (response.status === 200) {
// 			return Promise.resolve(response);
// 		} else {
// 			return Promise.reject(response);
// 		}
// 	},
// 	// 服务器状态码不是 2xx
// 	error => {
// 		if (error.response.status) {
// 			switch (error.response.status) {
// 				case 401:
// 					ElMessage({
// 						showClose: true,
// 						message: '未登录或登录过期，请登录',
// 						type: 'warning',
// 					})
// 					break;
// 				default:
// 					console.log(error.response)
// 			}
// 		}
// 		return Promise.reject(error.response);
// 	}

// )
/*
get请求
url请求的地址，
params请求参数
*/
export const get = (url, params,headers) => {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params,
		    headers:headers }).then(res => {
			resolve(res.data);
		}).catch(err => {
			console.log("err", err)
			reject(err.data)
		})
	})
}
/*
post请求
url请求的地址，
params请求参数
*/
export const post = (url, params,headers) => {
	
	return new Promise((resolve, reject) => {
		
		axios.post(url, params,{ headers:headers }).then(res => {
			resolve(res.data);
		}).catch(err => {
			console.log("err", err)
			reject(err.data)
		})
	})
}
/*
delete请求
url请求的地址，
params请求参数
*/
export const Delete = (url, params,headers) => {
	
	return new Promise((resolve, reject) => {
		
		axios.delete(url, params,{ headers:headers }).then(res => {
			resolve(res.data);
		}).catch(err => {
			console.log("err", err)
			reject(err.data)
		})
	})
}
/*
put请求
url请求的地址，
params请求参数
*/
export const put = (url, params,headers) => {
	return new Promise((resolve, reject) => {
		axios.put(url, params,{
			headers:headers
		}).then(res => {
			if (res.status >= 200 && res.status < 300) {
				resolve(res.data);
			} else {
				reject(new Error(`HTTP Error! Status: ${res.status}`));
			}
		}).catch(err => {
			reject(err.message || err);
		});
	});
}

